import { GroupByTransformPlainObject } from './groupByTransform.plainObject';

export class PivotBasePlainObject extends GroupByTransformPlainObject {
    public pivotKeyValues: string[] = [];
    public nullValue: boolean;
}
